import { useQuery } from '@tanstack/react-query'
import { useAtomValue } from 'jotai'
import { CourseRequest } from '@/types'
import { userAtom } from '@/store/store'
import { refreshAuthTokenAndUpdateUser } from '@/auth/utils'

const API_URL = import.meta.env.VITE_API_URL

const fetchRequests = async (userId: string, signal: AbortSignal): Promise<CourseRequest[]> => {
    const idToken = await refreshAuthTokenAndUpdateUser()
    const response = await fetch(`${API_URL}/api/requests/list?user_id=${userId}`, {
        method: 'GET',
        headers: {
            Authorization: `Bearer ${idToken}`,
        },
        signal,
    })

    if (!response.ok) {
        const body = await response.json()
        throw new Error(body.message || 'Failed to fetch requests')
    }

    return response.json()
}

export default function useRequests() {
    const user = useAtomValue(userAtom)

    return useQuery({
        queryKey: ['requests', user.userId],
        queryFn: ({ signal }) => fetchRequests(user.userId, signal),
        enabled: !!user.userId,
    })
}
